var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"modal-back"},[_c('transition',[_c('div',{staticClass:"modal-popup"},[_vm._t("default")],2)])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }